import { Firmware, FirmwareQueryParam, FirmwareUploadParam } from '/@/types/device-firmware'
import request, { CommonListResponse, IListWorkspaceResponse, IPage, IWorkspaceResponse } from '/@/api/http/request'
import { Device } from '/@/types/device'

const HTTP_PREFIX = '/manage/api/v1'

// login
export interface LoginBody {
 login_name: string,
 username: string,
 password: string,
 captcha_id: string,
 captcha_value:string,
 phone:string,
 phoneverify:string,
 flag: number,
}
// 验证码
export interface CaptchaBody {
  captcha_image: string,
  captcha_id:string
}

export interface BindBody {
  device_sn: string,
  user_id: string,
  workspace_id: string,
  domain?: string
}
export interface HmsQueryBody {
  sns: string[],
  children_sn: string,
  device_sn: string,
  language: string,
  level: number | string,
  begin_time: number,
  end_time: number,
  message: string,
  domain: number,
}

export interface DeviceTopoData {
  device_sn: string;
  device_name: string;
  workspace_id: string;
  control_source: string;
  device_desc: string;
  child_device_sn: string;
  domain: number;
  type: number;
  sub_type: number;
  icon_url: {
    normal_icon_url: string;
    selected_icon_url: string;
  };
  status: boolean;
  bound_status: boolean;
  login_time: string;
  nickname: string;
  firmware_version: string;
  workspace_name: string;
  children?: DeviceTopoData[];
  thing_status?: boolean;
  thing_version?: string;
  lat?: string;
  lot?: string;
}

export const login = async function (body: LoginBody): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/login`
  const result = await request.post(url, body)
  return result.data
}

export const logoutMethod = async function (): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/logout`
  const result = await request.post(url)
  return result.data
}

// 发送手机验证码
export const getPhoneCaptcha = async function (data) : Promise<IWorkspaceResponse<any>> {
  const url = '/manage/api/v1/send-phone-code'
  const result = await request.post(url, data)
  return result.data
}

// 手机验证码登录
export const getVerifyAndLogin = async function (data) : Promise<IWorkspaceResponse<any>> {
  const url = '/manage/api/v1/verify-phone-code'
  const result = await request.post(url, data)
  return result.data
}

// 验证码
export const captcha = async function (): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/captcha/generate`
  const result = await request.get(url)
  return result.data
}

// Refresh Token
export const refreshToken = async function (body: {}): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/token/refresh`
  const result = await request.post(url, body)
  return result.data
}

// Get Platform Info
export const getPlatformInfo = async function (): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/workspaces/current`
  const result = await request.get(url)
  return result.data
}

// Get Platform Info 审批的适用部门
export const getWorkSpaceList = async function (): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/workspaces/workspace-list`
  const result = await request.get(url)
  return result.data
}

export const getSystemTitle = async function (system_title:string): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/config/query-name-by-code/${system_title}`
  const result = await request.get(url)
  return result.data
}

// Get User Info
export const getUserInfo = async function (): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/users/current`
  const result = await request.get(url)
  return result.data
}

// Get Device Topo  根据工作空间id获取设备列表
export const getDeviceTopo = async function (workspace_id: string): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/devices/${workspace_id}/devices`
  const result = await request.get(url)
  return result.data
}

export interface DeviceBody{
  workspace_id: string
  domains: [] // 数组
}
// 根据入参获取设备列表
export const getDevice = async function (body: DeviceBody): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/devices/devices/list-param`
  const result = await request.post(url, body)
  return result.data
}

export const getDevicePlayLoads = async function (device_sn: string): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/devices/devices/playLoads/${device_sn}`
  const result = await request.get(url)
  return result.data
}

// Get Livestream Capacity
export const getLiveCapacity = async function (body: {}): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/live/capacity`
  const result = await request.get(url, body)
  return result.data
}

export interface VideoItem {
  id: string;
  switchVideoTypes: string[]; // 假设是字符串数组，如 ['主码流', '子码流']
}

export interface CameraItem {
  videosList: VideoItem[]; // 视频列表（数组，元素是 VideoItem 对象）
}

export interface VideoType {
  data: {
    camerasList: CameraItem[]; // 摄像头列表（数组，元素是 CameraItem 对象）
  }
}

export const getLiveCapacityByDeviceSn = async function (deviceSn: string): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/live/capacity/${deviceSn}`
  const result = await request.get(url)
  return result.data
}

export const getAgoraToken = async function (params:{appKey:string, channel:string}) {
  const url = '/manage/api/v1/live/stream/agora-token'
  const result = await request.get(url, { params })
  return result.data
}

// 开启直播流
export const startLivestream = async function (body: {}): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/live/streams/start`
  const result = await request.post(url, body)
  return result.data
}

// 停止直播流
export const stopLivestream = async function (body: {}): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/live/streams/stop`
  const result = await request.post(url, body)
  return result.data
}

// 开启视频分析
export const startVideoAnalysisLive = async function (body: {}, data): Promise<IWorkspaceResponse<any>> {
  const url = '/ai/api/v1/drone/inspection/start'
  const result = await request.post(url, body, { params: data })
  return result.data
}

// 停止视频分析
export const stopVideoAnalysisLive = async function (params): Promise<IWorkspaceResponse<any>> {
  const url = '/ai/api/v1/drone/inspection/stop'
  const result = await request.post(url, params)
  return result.data
}

// 切换舱内舱外
export const liveCameraSwitch = async function (body: {}): Promise<IWorkspaceResponse<any>> {
  const url = '/manage/api/v1/live/streams/cameraChange'
  const result = await request.post(url, body)
  return result.data
}

export const getLiveStreamUrlList = async function (body: {}): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/live/stream/live-url`
  const result = await request.get(url, { params: body })
  return result.data
}
// Update Quality
export const setLivestreamQuality = async function (body: {}): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/live/streams/update`
  const result = await request.post(url, body)
  return result.data
}

export const getAllUsersInfo = async function (wid: string, body: IPage): Promise<CommonListResponse<any>> {
  const url = `${HTTP_PREFIX}/users/${wid}/users?&page=${body.page}&page_size=${body.page_size}`
  const result = await request.get(url)
  return result.data
}

export const updateUserInfo = async function (wid: string, user_id: string, body: {}): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/users/${wid}/users/${user_id}`
  const result = await request.put(url, body)
  return result.data
}

export const bindDevice = async function (body: BindBody): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/devices/${body.device_sn}/binding`
  const result = await request.post(url, body)
  return result.data
}

export const unbindDevice = async function (device_sn: string): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/devices/${device_sn}/unbinding`
  const result = await request.delete(url)
  return result.data
}

export const getDeviceBySn = async function (workspace_id: string, device_sn: string): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/devices/${workspace_id}/devices/${device_sn}`
  const result = await request.get(url)
  return result.data
}

/**
 * 获取绑定设备信息
 * @param workspace_id
 * @param body
 * @param domain
 * @returns
 */
export const getBindingDevices = async function (workspace_id: string, body: IPage, domain: number): Promise<IListWorkspaceResponse<Device>> {
  const url = `${HTTP_PREFIX}/devices/${workspace_id}/devices/bound?&page=${body.page}&page_size=${body.page_size}&domain=${domain}`
  const result = await request.get(url)
  return result.data
}

export const updateDevice = async function (body: {}, workspace_id: string, device_sn: string): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/devices/${workspace_id}/devices/${device_sn}`
  const result = await request.put(url, body)
  return result.data
}

// hms信息提示
export const getUnreadDeviceHms = async function (workspace_id: string, device_sn: string): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/devices/${workspace_id}/devices/hms/${device_sn}`
  const result = await request.get(url)
  return result.data
}

// hms信息提示
export const updateDeviceHms = async function (workspace_id: string, device_sn: string): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/devices/${workspace_id}/devices/hms/${device_sn}`
  const result = await request.put(url)
  return result.data
}

export const getDeviceHms = async function (body: HmsQueryBody, workspace_id: string, pagination: IPage): Promise<IListWorkspaceResponse<any>> {
  let url = `${HTTP_PREFIX}/devices/${workspace_id}/devices/hms?page=${pagination.page}&page_size=${pagination.page_size}` +
    `&level=${body.level ?? ''}&begin_time=${body.begin_time ?? ''}&end_time=${body.end_time ?? ''}&message=${body.message ?? ''}&language=${body.language}`
  body.sns.forEach((sn: string) => {
    if (sn !== '') {
      url = url.concat(`&device_sn=${sn}`)
    }
  })
  const result = await request.get(url)
  return result.data
}

export const changeLivestreamLens = async function (body: {}): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/live/streams/switch`
  const result = await request.post(url, body)
  return result.data
}

export const getFirmwares = async function (workspace_id: string, page: IPage, body: FirmwareQueryParam): Promise<IListWorkspaceResponse<Firmware>> {
  const url = `${HTTP_PREFIX}/workspaces/${workspace_id}/firmwares?page=${page.page}&page_size=${page.page_size}` +
    `&device_name=${body.device_name}&product_version=${body.product_version}&status=${body.firmware_status ?? ''}`
  const result = await request.get(url)
  return result.data
}

export const importFirmareFile = async function (workspaceId: string, param: FormData): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/workspaces/${workspaceId}/firmwares/file/upload`
  const result = await request.post(url, param)
  return result.data
}

export const changeFirmareStatus = async function (workspaceId: string, firmwareId: string, param: {status: boolean}): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/workspaces/${workspaceId}/firmwares/${firmwareId}`
  const result = await request.put(url, param)
  return result.data
}

// 根据objectKey获取url
export const getAthVideo = async function (param: FormData): Promise<IWorkspaceResponse<any>> {
  const url = `${HTTP_PREFIX}/files/get-url-by-object-key`
  const result = await request.post(url, param)
  return result.data
}

/** 获取方圆4公里的机场设备 */
export const getNearestDeviceNew = async function (data:{lon:number, lat:number}) {
  const url = `${HTTP_PREFIX}/devices/get-nearest-device-new`
  const result = await request.post(url, '', { params: data })
  return result.data
}

// 校验视频流是否在解析
export const checkOdmVideoIsParse = async function (param: FormData): Promise<IWorkspaceResponse<any>> {
  const url = '/uav-algorithm/business/onnx/v2/check-video-stream'
  const result = await request.post(url, param, { customToken: true })
  return result.data
}

// 视频识别并推流（指定算法，异步）
export const getOdmVideo = async function (body: {}): Promise<IWorkspaceResponse<any>> {
  const url = '/uav-algorithm/business/onnx/v2/detect-stream-multi'
  const result = await request.post(url, body, { customToken: true })
  return result.data
}

// 停止视频流解析
export const stopOdmVideo = async function (param: FormData): Promise<IWorkspaceResponse<any>> {
  const url = '/uav-algorithm/business/onnx/stop-video-stream'
  const result = await request.post(url, param, { customToken: true })
  return result.data
}
